import {BingMaps, Vector as VectorSource} from 'ol/source';
import TileLayer from 'ol/layer/Tile';
import View from 'ol/View';
import {transform} from 'ol/proj';
import Feature from 'ol/Feature';
import {Point} from 'ol/geom';
import {Fill, Icon, Stroke, Style} from 'ol/style';
import {Vector as VectorLayer} from 'ol/layer';

// @ts-ignore
export const update = async ({state, dispatch}, map) => {
  try {
    state.map = map;

    state.flag = new Feature({
      geometry: new Point([1515295.3699775967, 6029164.358547934]),
      name: 'Null Island',
      population: 4000,
      rainfall: 500,
    });

    const flagStyle = new Style({
      image: new Icon({
        imgSize: [56, 72],
        scale: 0.3,
        anchor: [0.0, 0.99],
        src: '/images/autocomplete-map-point.png',
      }),
    });

    state.flag.setStyle(flagStyle);

    const source = new VectorSource({
      features: [state.flag],
    });

    const vLayer = new VectorLayer({
      source,
      style: (feature) => {
        return new Style({
          // adding an image here does not work, maybe add the layer and then do some hide/show tactic?
          image: new Icon({
            src: '/images/autocomplete-map-point.png',
            imgSize: [56, 72],
            scale: 0.3,
            anchor: [0.0, 0.99],
            crossOrigin: 'anonymous',
          }),
        });
      },
    });

    vLayer.setVisible(false);

    state.flagLayer = vLayer;
    dispatch('addLayer', vLayer);

    return true;
  } catch (ex) {
    dispatch('common/snackbar/error', ex, {root: true});
    return false;
  }
};

// @ts-ignore
export const init = async ({state, dispatch}) => {
  try {
    state.tileSource = new BingMaps({
      key: 'AjI3mr1zpwgCpkEXxAFKLGEQjiovDVvCfcQzWQR5WQ9UhnbMHlEKAk_ZemdyQFLT',
      imagerySet: 'RoadOnDemand',
    });

    state.tiles = new TileLayer({
      preload: Infinity,
      source: state.tileSource,
    });

    state.view = new View({
      projection: 'EPSG:3857',
      // WebMercator
      extent: [957610.8116089507, 5750016.331250471, 2072979.9283462428, 6308312.385845398],
      center: [1515295.3699775967, 6029164.358547934],
      zoom: 8,
      minZoom: 7,
    });

    return {view: state.view, tiles: state.tiles};
  } catch (ex) {
    dispatch('common/snackbar/error', ex, {root: true});
    return false;
  }
};

// @ts-ignore
export const addLayer = async ({commit, dispatch, state}, layer) => {
  state.map.addLayer(layer);
  // state.map.getView().fit(layer.getSource().getExtent());
};

// @ts-ignore
export const removeLayer = async ({commit, dispatch, state}, layer) => {
  state.map.removeLayer(layer);
  // state.map.getView().fit(layer.getSource().getExtent());
};

// @ts-ignore
export const addOverlay = async ({commit, dispatch, state}, overlay) => {
  state.map.addOverlay(overlay);
};

// @ts-ignore
export const centerOn = async ({commit, dispatch, state}, source) => {
  state.map.getView().fit(source.getExtent());
};

// @ts-ignore
export const centerOnBbox = async ({commit, dispatch, state}, gps) => {
  state.map.getView().setCenter(transform([gps[1], gps[0]], 'EPSG:4326', 'EPSG:3857'));
  state.map.getView().setZoom(14);

  state.flag.getGeometry().setCoordinates(transform([gps[1], gps[0]], 'EPSG:4326', 'EPSG:3857'));
  state.flagLayer.setVisible(true);
};

// @ts-ignore
export const chooseAddress = async ({commit, dispatch, state}, {gps, name}) => {
  commit('setName', name);
  commit('setAddress', gps);
};

// @ts-ignore
export const unset = async ({state}) => {
  state.map = undefined;
};

// @ts-ignore
export const createScreenshot = async ({state}) => {
  state.map.once('rendercomplete', (event: any) => {
    const canvas = event.context.canvas;
    state.img = canvas.toDataURL('image/jpeg', 1);
  });

  await state.map.renderSync();
  return state.img;
};
